<template>
  <div class="prev-next">
    <button :class="prevClass"
            :disabled="isPrevDisabled"
            @click="onNext">
      <font-awesome-icon icon="chevron-left"
                         size="xs"></font-awesome-icon>
      {{ ui.previous.label }}
    </button>
    <button :class="nextClass"
            :disabled="isNextDisabled"
            @click="onPrevious">
      {{ ui.next.label }}
      <font-awesome-icon icon="chevron-right"
                         size="xs"></font-awesome-icon>
    </button>
  </div>
</template>
<script>
export default {
  name: "PrevNext",
  props: {
    prevClass: {
      type: String,
      default: "cta cta--secondary",
    },
    nextClass: {
      type: String,
      default: "cta cta--primary--alt",
    },
    isNextDisabled: {
      type: Boolean,
      default: false,
    },
    isPrevDisabled: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ( {
    ui: {
      previous: {
        label: "Back",
      },
      next: {
        label: "Next",
      },
    },
  } ),
  methods: {
    onPrevious () {
      if ( this.isNextDisabled === false ) {
        this.$emit( "next" );
      }
    },
    onNext () {
      if ( this.isPrevDisabled === false ) {
        this.$emit( "previous" );
      }
    },
  },
};
</script>

<style lang="less" scoped>
@import "../../Styles/utils/index.less";

.prev-next {
  display: flex;
  flex: 1;
  justify-content: space-between;
  margin: 16px 0;

  > button {
    align-items: center;
    display: flex;
    justify-content: center;
    gap: 8px;
    margin-right: 16px;

    &:last-child {
      margin-right: 0;
    }
  }
}
</style>
